import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../environments/environment";
import { Country } from "./shared.service";
import { AppConfig } from "./models/appConfig.model";
import { StoredBootstrap } from "./bootstrap/bootstrap.model";

export class AppLocalStorageObject {
    lang: string;
    countries?: Country[];
    bootstrap?: StoredBootstrap;
}

export class UserLocalStorageObject {
    username: string;
    sessionToken: string;
    userName: string;
    organizationId: number;
    showPilotHourLimits: boolean;
    htlAccountTypes: any;
    displayedColumns?: any[];
    appConfigs?: AppConfig[];
    exportPresetFilters?: any[];
    constructor(
        username: string,
        sessionToken: string,
        userName: string,
        organizationId: number,
        showPilotHourLimits: boolean,
        htlAccountTypes: any,
        appConfigs: AppConfig[],
        exportPresetFilters: any[],
        displayedColumns?: any[],
    ) {
        this.username = username;
        this.sessionToken = sessionToken;
        this.userName = userName;
        this.organizationId = organizationId;
        this.showPilotHourLimits = showPilotHourLimits;
        this.htlAccountTypes = htlAccountTypes;
        this.appConfigs = appConfigs;
        this.exportPresetFilters = exportPresetFilters;
        this.displayedColumns = displayedColumns;
    }
}

@Injectable({
    providedIn: "root",
})
export class LocalStorageService {
    public userLocalStorageInserted = new BehaviorSubject(this.getUserLocalStorageObject());

    constructor() {}

    private _getLocalStorage(uniqueId: string) {
        return localStorage.getItem(uniqueId);
    }

    private _setLocalStorage(key: string, value: string) {
        localStorage.setItem(key, value);
    }

    /**
     * USER LOCAL STORAGE
     */
    public userLocalStorageExist(): boolean {
        return !!this._getLocalStorage(environment.userSessionUniqueId);
    }

    public getUserLocalStorageObject(): UserLocalStorageObject {
        const currentLocalStorage = this._getLocalStorage(environment.userSessionUniqueId);
        return JSON.parse(currentLocalStorage);
    }

    public setUserLocalStorage(key: string, value: any) {
        const localStorageObject: UserLocalStorageObject = JSON.parse(this._getLocalStorage(environment.userSessionUniqueId));
        localStorageObject[key] = value;
        this._setLocalStorage(environment.userSessionUniqueId, JSON.stringify(localStorageObject));
        this.userLocalStorageInserted.next(localStorageObject);
    }

    /**
     * APP LOCAL STORAGE
     */
    public appLocalStorageExist(): boolean {
        return !!this._getLocalStorage(environment.appSessionUniqueId);
    }

    public getAppLocalStorageObject(): AppLocalStorageObject {
        const currentLocalStorage = this._getLocalStorage(environment.appSessionUniqueId);
        const object = JSON.parse(currentLocalStorage);
        if (object.countries) {
            object.countries = JSON.parse(object.countries);
        }
        return object;
    }

    public setAppLocalStorage(key: string, value: any) {
        let localStorageObject = new AppLocalStorageObject();
        if (this.appLocalStorageExist()) {
            localStorageObject = JSON.parse(this._getLocalStorage(environment.appSessionUniqueId));
        }
        localStorageObject[key] = value;
        this._setLocalStorage(environment.appSessionUniqueId, JSON.stringify(localStorageObject));
    }
}
